<template>
  <a :href="`/cleaner/${professional.id}`" @click.prevent="goToProfessionalDetail(professional)">
    <div class="card h-100 m-0 shadow-sm">
      <div class="card-image">
        <div v-lazy:background-image="{
                src: professional.cover_photo,
                error: '/static/img/preview-img.jpg',
                loading: '/static/img/preview-img.jpg'}"
             class="cover-photo-sm"></div>
      </div>
      <div class="card-body text-comment" :class="[$mq.phone ? 'p-2' : 'p-3']">
        <div class="short-description-box">
            <span v-html="$options.filters.shortText(professional.short_description, 70)"
                  v-if="professional.short_description"></span>
          <span v-else>
              {{ $t('message.home.service01') }}
            </span>
        </div>
        <div class="d-flex mt-3">
          <div class="flex-shrink-1">
            <professional-picture :professional="professional"
                                  :imgClass="'professional-picture'"
                                  :imgSize="44"
                                  :badgeSize="18"/>
          </div>
          <div class="w-100 pl-2">
            <div class="d-flex">
              <div class="flex-grow-1">
                {{ professional.name | firstName | shortText(15) }}
              </div>
              <div class="text-right text-small">
                <span v-if="professional.rating && professional.rating > 0 ">
                  <i class="fas fa-star -rating-star"></i> {{ Number(professional.rating).toFixed(1) }}
                </span>
              </div>
            </div>
            <div class="text-remark">
              <span>{{ professional.rating_qty }} {{ $tc('message.professional.review', professional.rating_qty)}}</span>
              ·
              <span class="text-secondary" v-if="professional.is_excellent === 1">
                {{ globalState.cities[professional.province_id] | multiLangName | shortText(12) }}
              </span>
              <span class="text-secondary" v-else>
                {{ globalState.cities[professional.province_id] | multiLangName }}
              </span>
            </div>
          </div>
        </div>

        <div class="d-flex text-small pt-2">
          <div class="flex-fill">
            <div v-for="(service, index) in professional.services"
                 class="d-inline-block"
                 :class="{'pl-2': index > 0}"
                 v-b-tooltip.hover
                 :title="$options.filters.multiLangName(service)"
                 v-if="service.icon_url">
              <img :src="service.icon_url" height="22">
            </div>
          </div>
          <div class="flex-fill text-right">
            <b class="text-info">{{ professional.cost_per_hour | currency }}</b>/{{ $tc('message.hour', 1) }}
          </div>
        </div>

        <!-- Vaccination section -->
        <div class="vaccine-section">
          <professional-vaccination :professional="professional"/>
        </div>

      </div>
    </div>
  </a>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ProfessionalPicture from '../../professional/components/ProfessionalPicture'
  import ProfessionalVaccination from '../../professional/components/ProfessionalVaccination'

  export default {
    props: {
      professional: Object
    },
    components: {
      ProfessionalPicture,
      ProfessionalVaccination
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      getService (serviceId) {
        return this.globalState.services[serviceId]
      },
      goToProfessionalDetail (professional) {
        // Check route to detect parent component
        const path = this.$route.matched[0].path
        let parent = null
        if (path === '/recommend/:id') {
          parent = this.$parent.$parent
        } else {
          parent = this.$parent.$parent.$parent
        }
        let numServices = 0
        numServices += professional.services.length
        if (professional.experiences) {
          numServices += professional.experiences.length
        }
        if (numServices > 1) {
          parent.openProfessionalServiceModal(professional)
        } else {
          if (professional.services && professional.services.length > 0) {
            // this.$router.push('/cleaner/' + professional.id)
            let routeData = this.$router.resolve('/cleaner/' + professional.id)
            window.open(routeData.href, '_blank')
          } else if (professional.experiences && professional.experiences.length > 0) {
            // this.$router.push('/experience/' + professional.experiences[0].id)
            let routeData = this.$router.resolve('/special-services/' + professional.experiences[0].id)
            window.open(routeData.href, '_blank')
          }
        }
      },
      firstName (professionalName) {
        return this.$options.filters.firstName(professionalName)
      }
    }
  }
</script>

<style scoped>
  .short-description-box {
    height: 2.2em;
    line-height: 1.1;
    overflow: hidden;
  }

  .vaccine-section {
    font-size: 86%;
  }
</style>



// WEBPACK FOOTER //
// src/components/recommend/components/RecommendProfessional.vue